const categoryHierarchy = {
    problème_de_paiement: {
        label: "Problème de paiement",
        fieldId: "17726223797532",
        value: "problème_de_paiement",
        options: [
            {
                value: "double_facturation",
                label: "Double facturation",
                fieldId: "17726223797532",
                subcategories: []
            },
            {
                value: "question_sur_ma_facture",
                label: "Question sur ma facture",
                fieldId: "17726223797532",
                subcategories: []
            },
            {
                value: "paiement_refusé",
                label: "Paiement refusé",
                fieldId: "17726223797532",
                subcategories: []
            },
            {
                value: "problème_avec_un_code_promo",
                label: "Problème avec un code promo",
                fieldId: "17726223797532",
                subcategories: []
            }
        ]
    },
    livraison: {
        label: "Livraison",
        fieldId: "17726263944092",
        value: "livraison",
        options: [
            {
                value: "suivre_mon_colis",
                label: "Suivre mon colis",
                fieldId: "17726313132700",
                subcategories: [
                    { value: "où_est_mon_colis__", label: "Où est mon colis ?", fieldId: "17726313132700" },
                    { value: "mon_colis_a-t-il_été_expédié__", label: "Mon colis a-t-il été expédié ?", fieldId: "17726313132700" },
                    { value: "quand_vais-je_recevoir_mon_colis__", label: "Quand vais-je recevoir mon colis ?", fieldId: "17726313132700" },
                    { value: "demander_le_numéro_de_suivi__pensez_à_vérifier_dans_les_spams_", label: "Demander le numéro de suivi (pensez à vérifier dans les spams)", fieldId: "17726313132700" }
                ]
            },
            {
                value: "problème_de_livraison",
                label: "Problème de livraison",
                fieldId: "17726333096604",
                subcategories: [
                    { value: "colis_retardé", label: "Colis retardé", fieldId: "17726333096604" },
                    { value: "colis_perdu", label: "Colis perdu", fieldId: "17726333096604" },
                    { value: "colis_marqué_comme__livré__mais_non_reçu__confirmer_l’adresse_", label: "Colis marqué comme livré mais non reçu (confirmer l’adresse)", fieldId: "17726333096604" },
                    { value: "colis_endommagé_ou_incomplet__envoyez-nous_des_photos_pour_qu_on_vous_aide_rapidement_", label: "Colis endommagé ou incomplet (envoyez-nous des photos)", fieldId: "17726333096604" },
                    { value: "adresse_incorrecte", label: "Adresse incorrecte", fieldId: "17726333096604" }
                ]
            }
        ]
    },
    commande: {
        label: "Commande",
        fieldId: "17726371830812",
        value: "commande",
        options: [
            {
                value: "modifier_ma_commande",
                label: "Modifier ma commande",
                fieldId: "17726327592476",
                subcategories: [
                    { value: "ajouter_ou_supprimer_un_produit__dans_les_24_heures_suivant_la_commande_", label: "Ajouter ou supprimer un produit (dans les 24 heures suivant la commande)", fieldId: "17726327592476" },
                    { value: "modifier_l’adresse_de_livraison__dans_les_24_heures_suivant_la_commande_", label: "Modifier l’adresse de livraison (dans les 24 heures suivant la commande)", fieldId: "17726327592476" }
                ]
            },
            {
                value: "annuler_ma_commande",
                label: "Annuler ma commande",
                fieldId: "17726379432476",
                subcategories: [
                    { value: "annulation_totale_ou_partielle__dans_les_24_heures_suivant_la_commande_", label: "Annulation totale ou partielle (dans les 24 heures suivant la commande)", fieldId: "17726379432476" }
                ]
            },
            {
                value: "problème_avec_ma_commande",
                label: "Problème avec ma commande",
                fieldId: "17726381211932",
                subcategories: [
                    { value: "produit_incorrect_ou_manquant", label: "Produit incorrect ou manquant", fieldId: "17726381211932" },
                    { value: "question_sur_la_disponibilité_d’un_produit", label: "Question sur la disponibilité d’un produit", fieldId: "17726381211932" }
                ]
            }
        ]
    },
    produit: {
        label: "Produit",
        fieldId: "17726430260636",
        value: "produit",
        options: [
            {
                value: "problème_avec_le_produit",
                label: "Problème avec le produit",
                fieldId: "17726425349532",
                subcategories: [
                    { value: "produit_ne_fonctionne_pas_correctement__comment_allumer_la_lumière__", label: "Produit ne fonctionne pas correctement > Comment allumer la lumière ?", fieldId: "17726425349532" },
                    { value: "produit_ne_fonctionne_pas_correctement__quelles_piles_utiliser____il_en_faut_une__type_aaa_", label: "Produit ne fonctionne pas correctement > Quelles piles utiliser ? (Type AAA)", fieldId: "17726425349532" },
                    { value: "produit_ne_fonctionne_pas_correctement__comment_bien_ajuster_les_molettes__", label: "Produit ne fonctionne pas correctement > Comment bien ajuster les molettes ?", fieldId: "17726425349532" },
                    { value: "produit_ne_fonctionne_pas_correctement__je_vois_tout_blanc__est-ce_normal__", label: "Produit ne fonctionne pas correctement > Je vois tout blanc, est-ce normal ?", fieldId: "17726425349532" },
                    { value: "produit_ne_fonctionne_pas_correctement__je_ne_vois_rien_avec_le_petiscope", label: "Produit ne fonctionne pas correctement > Je ne vois rien avec le Petiscope.", fieldId: "17726425349532" },
                    { value: "produit_ne_fonctionne_pas_correctement__je_n_arrive_pas_à_fermer_le_cache", label: "Produit ne fonctionne pas correctement > Je n'arrive pas à fermer le cache", fieldId: "17726425349532" },
                    { value: "produit_reçu_endommagé", label: "Produit reçu endommagé.", fieldId: "17726425349532" }
                ]
            },
            {
                value: "questions_sur_le_produit",
                label: "Questions sur le produit",
                fieldId: "17726394503196",
                subcategories: [
                    { value: "fonctionnalités_ou_utilisation", label: "Fonctionnalités ou utilisation", fieldId: "17726394503196"},
                    { value: "accessoires_ou_options_disponibles", label: "Accessoires ou options disponibles.", fieldId: "17726394503196"},
                ]
            }
        ]
    },
    retours_et_remboursements: {
        label: "Retours et Remboursements",
        fieldId: "17726464624796",
        value: "retours_et_remboursements",
        options: [
            {
                value: "demander_un_retour",
                label: "Demander un retour",
                fieldId: "17726481389084",
                subcategories: [
                    { value: "produit_non_utilisé__merci_d’indiquer_le_motif_", label: "Produit non utilisé (merci d’indiquer le motif)", fieldId: "17726481389084" },
                    { value: "produit_défectueux", label: "Produit défectueux", fieldId: "17726481389084" },
                    { value: "je_n_ai_pas_reçu_ce_que_j_ai_commandé", label: "Je n'ai pas reçu ce que j'ai commandé", fieldId: "17726481389084" }
                ]
            },
            {
                value: "suivre_ma_demande_de_retour",
                label: "Suivre ma demande de retour",
                fieldId: "17726464624796",
                subcategories: []
            },
            {
                value: "demande_de_remboursement",
                label: "Demande de remboursement",
                fieldId: "17726464624796",
                subcategories: []
            }
        ]
    },
    assistance_générale: {
        label: "Assistance Générale",
        fieldId: "17726515358108",
        value: "assistance_générale",
        options: [
            {
                value: "suggestions_ou_remarques_sur_le_produit",
                label: "Suggestions ou remarques sur le produit",
                fieldId: "17726515358108",
                subcategories: []
            },
            {
                value: "je_donne_mon_avis_sur_le_petiscope_et_les_autres_outils_d_aventurier",
                label: "Je donne mon avis sur le Petiscope et les autres outils d'aventurier",
                fieldId: "17726515358108",
                subcategories: []
            },
            {
                value: "problèmes_non_listés_ou_spécifiques",
                label: "Problèmes non listés ou spécifiques",
                fieldId: "17726515358108",
                subcategories: []
            }
        ]
    }
};
